import React from 'react';
import { Statistic, Card, Row, Col, Icon } from 'antd';
import { useGetGeneralTemplateReport } from '../../../query/template';
import colors from 'constants/colors';

function getUnoptimizedTemplatesColor(unoptimized = 0, total = 0) {
  const percentage = unoptimized / total;
  if (percentage > 0.8) {
    return colors.ERROR;
  }
  if (percentage > 0.3) {
    return colors.WARNING;
  }
  return colors.SUCCESS;
}

export default function GeneralTemplateReport() {
  const { data } = useGetGeneralTemplateReport();
  return (
    <Row gutter={16}>
      <Col span={8}>
        <Card>
          <Statistic
            precision={0}
            suffix="templates"
            title="Unoptimized / Total Templates"
            value={`${data?.unoptimizedTemplates ||
              0} / ${data?.totalTemplates || 0}`}
            valueStyle={{
              color: getUnoptimizedTemplatesColor(
                data?.unoptimizedTemplates,
                data?.totalTemplates,
              ),
            }}
          />
        </Card>
      </Col>
      <Col span={8}>
        <Card>
          <Statistic
            suffix="errors"
            title="Total Errors"
            value={data?.totalErrors}
            valueStyle={{ color: colors.ERROR }}
          />
        </Card>
      </Col>
      <Col span={8}>
        <Card>
          <Statistic
            suffix="warnings"
            title="Total Warnings"
            value={data?.totalWarnings}
            valueStyle={{ color: colors.WARNING }}
          />
        </Card>
      </Col>
    </Row>
  );
}
